import { render, staticRenderFns } from "./DataImportRunScript.vue?vue&type=template&id=0056bd39&scoped=true&"
import script from "./DataImportRunScript.vue?vue&type=script&lang=js&"
export * from "./DataImportRunScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0056bd39",
  null
  
)

export default component.exports